import { useCallback } from 'react';
import PropTypes from 'prop-types';
import SalaryRange from './salaryRange';
import { replaceObjectInList } from '../../../utility/helpers';

const SalaryRanges = ({
  translations,
  values,
  currency = '',
  fieldTypes,
  error = null,
  onChange,
  ...rest
}) => {
  const handleChangeValue = useCallback(
    (field, fieldIndex) => {
      onChange(replaceObjectInList(values, fieldIndex, field));
    },
    [values, onChange]
  );

  return values.map((val, index) => (
    <div key={`item_${index}`}>
      <SalaryRange
        id={index}
        translations={translations}
        value={val}
        currency={currency}
        fieldTypes={fieldTypes}
        error={error?.[index]}
        onChange={handleChangeValue}
        {...rest}
      />
    </div>
  ));
};

SalaryRanges.propTypes = {
  translations: PropTypes.object.isRequired,
  values: PropTypes.arrayOf(PropTypes.object),
  fieldTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  error: PropTypes.object,
  currency: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default SalaryRanges;
